<template>
    <BaseNew
        @new-confirm-action="createEntry"
        @new-cancel-action="resetForm"
        @new-open-action="loadServerEntry"
        @clear-form-errors="clearFormErrors"
        ref="baseNew"
        width="80%"
        :formErrors="formErrors"
        :loading="loading"
        :hideSaveButton="true"
        addButtonIcon="mdi-tractor"
        :inlineAddButton="true"
        :pageLoading="pageLoading"
        :modelNameSingular="modelNameSingular">
        <template slot="newForm">
            <BaseUtil ref="util" :pageLoading="pageLoading" />
            <v-row>
                <v-col cols="12" sm="6">
                    <DateField
                        :inputData.sync="planningData.date"
                        label="Data do semeio"
                        :hasTodayButton="true"
                        :hasTodayDate="true"
                        autocomplete="off" />
                </v-col>
                <v-col cols="12">
                    <MultiSelect
                        v-model="planningData.planningIds"
                        label="Planejamentos"
                        :items="planningsList"
                        :loadingItems="planningsListLoading"
                        itemSubText="additionalInfo"
                        itemSecondSubText="secondAdditionalInfo"
                        :maxLimit="null">
                    </MultiSelect>
                </v-col>
                <v-col cols="12">
                    <NewSeedPlotOperation :planningData="planningData" @entry-created="entryCreated"/>
                </v-col>
            </v-row>
        </template>
    </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
// import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";
import BaseUtil from "@shared_components/base_util.vue";
// import MaskedTextField from "@shared_components/masked_text_field.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import DateField from "@shared_components/date_field.vue";
import NewSeedPlotOperation from "../seed_plot_operations/index_for_planning.vue";

export default {
    data() {
        return {
            error: null,
            loading: false,
            pageLoading: false,
            entry: null,
            formErrors: [],
            extraData: null,
            date: null,
            planningIds: [this.planningOperation.id],
            planningsList: null,
            planningsListLoading: false,
            planningData: {},
        };
    },
    props: {
        modelNameSingular: {
            type: String,
            default: ""
        },
        planningOperation: Object,
    },
    components: {
        // Form: Form,
        BaseNew: BaseNew,
        BaseUtil: BaseUtil,
        DateField: DateField,
        MultiSelect: MultiSelect,
        NewSeedPlotOperation: NewSeedPlotOperation,
    },
    created() {
        // console.log("pld", this.planningData);
        this.planningData.planningIds = [this.planningOperation.id];
        this.planningData.date = "";
    },
    methods: {
        loadServerEntry: function () {
            this.error = null;
            this.loading = true;
            this.$apollo
                .query({
                    query: LOAD_PLANNINGS_LIST_QUERY,
                    fetchPolicy: "no-cache",
                    variables: {
                        id: this.planningOperation.id,
                    }
                })
                .then(response => {
                    this.planningsList = response.data.accountContext.planningSeedPlotOperationsList;
                    // console.log("list", this.planningsList);
                    // this.extraData = response.data;
                })
                .catch(response => console.log(response))
                .finally(() => (this.loading = false));

        },
        createServerEntry: function (saleOrder) {
            // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
            this.pageLoading = true;
            this.$apollo
                .mutate({
                    mutation: CREATE_MULTIPLE_SEED_PLOT_OPERATION_MUTATION,
                    variables: {
                        interval: this.interval,
                        estimatedDeliveryDate: this.estimatedDeliveryDate + "",
                        quantity: this.quantity,
                        firstSowing: this.date + "",
                        saleOrderId: this.saleOrder.id,
                    }
                })
                .then(response => {
                    var error = response.data.createMultiplePlanningSeedPlotOperation.success

                    console.log("new seed plot ope", error);

                    if (error) {
                        // this.formErrors = errors
                        this.$refs.baseNew.closeDialog();
                        // this.resetForm();
                        this.$emit("entry-created");
                    } else {
                        console.log("erro");
                    }
                })
                .catch(error => {
                    let {
                        graphQLErrors,
                        networkError,
                        response,
                        operation
                    } = error;
                    console.log("error", error)
                    console.log("caiu no catch");
                    console.log(graphQLErrors);
                    console.log(networkError);
                    console.log(response);
                    console.log(operation);
                    if (networkError) {
                        console.log(`[Network error]: ${networkError}`);
                    } else if (graphQLErrors) {
                        graphQLErrors.map(({
                                message,
                                locations,
                                path
                            }) =>
                            console.log(
                                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                            )
                        );
                    }
                })
                .finally(() => (this.pageLoading = false));
        },
        createEntry: function () {
            // if (this.$refs.form.isFormValid()) {
            this.createServerEntry(this.entry);
            // }
        },
        entryCreated: function(){
            // console.log("entryCreated called !!!");
            this.$emit("entry-created");
        },
        resetForm: function () {
            if (this.$refs.form) {
                this.$refs.form.resetFormInputs();
            }
            this.formErrors = [];
        },
        clearFormErrors: function () {
            this.formErrors = [];
        }
    }
};

const LOAD_PLANNINGS_LIST_QUERY = gql `
  query($id: ID!){
    accountContext {
      planningSeedPlotOperationsList(planningSeedPlotOperationId: $id) {
        id
        name
        secondAdditionalInfo
        additionalInfo
      }
    }
  }
`;

const CREATE_MULTIPLE_SEED_PLOT_OPERATION_MUTATION = gql `
  mutation($interval: Int!, $quantity: Int!, $firstSowing: String!, $estimatedDeliveryDate: String!, $saleOrderId: ID!) {
    createMultiplePlanningSeedPlotOperation(interval: $interval, quantity: $quantity, firstSowing: $firstSowing, estimatedDeliveryDate: $estimatedDeliveryDate, saleOrderId: $saleOrderId) {
      success
    }
  }
`;
</script>

<style scoped></style>

<!--
mutation {
  createSale(
    customerId: 3,
    deliveryDate: "2020-01-31",
    saleProductsAttributes: [
      {price: 100, quantity: 10, itemId: 14, storehouseId: 3}
    ],
    paymentsAttributes: [
      {value: 1000, numberOfInstallments: 1, initialDate:"2020-01-31", bankAccountId: 1, paymentMethodId: 16}
    ]
  ){
    cashFlow {
      id
    }
    errors
  }
}
 -->
